import HeaderPageTitle from "Components/Base/HeaderPageTitle";
import Cities, { ICity } from "Components/Form/Inputs/Cities";
import RangeField from "Components/Form/Inputs/RangeField";
import States, { IState } from "Components/Form/Inputs/States";
import List2 from "Components/List2";
import api from "Helpers/Api";
import stringRange from "Helpers/stringRange";
import { useJobs } from "Hooks/Jobs/useJobs";
import React, { useCallback, useState } from "react";
import Routes from "Routes";
import { TJob } from "Services/Job/job";
import { IPagination, TRange } from "Services/pagination";
import * as Styledd from "../../../Components/Filters2/styles";
import ListItem from "./ListItem";
import * as Styled from "./styles";
import { useSelector } from "react-redux";
import { ReducerState } from "Redux/store";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { TSortingValue } from "Components/Sorting";

interface Props {
  row?: number;
  perPage?: number;
  hideSearch?: boolean;
  hidePagination?: boolean;
  hideFilters?: boolean;
  inline?: boolean;
  userId?: number;
  segment: "jobs" | "services";
  title?: string;
  published?: boolean;
  link?: string;
  setNoResults?: React.Dispatch<React.SetStateAction<boolean>>;
}

const JobList: React.FC<Props> = ({
  row = 3,
  perPage = 15,
  hideSearch = false,
  hideFilters = false,
  hidePagination = false,
  inline = false,
  userId,
  segment,
  published = true,
  title,
  link = "",
  setNoResults,
}) => {
  const [search, setSearch] = useState("");
  const [searchData, setSearchData] = useState("");
  const [states, setStates] = useState<IState[]>([]);
  const [cities, setCities] = useState<ICity[]>([]);
  const [salaryRange, setSalaryRange] = useState<TRange>({ min: 0, max: 0 });
  const [undefinedSalaries, setUndefinedSalaries] = useState<boolean>(true);
  const [queryError, setQueryError] = useState<boolean>(false);
  const { mobile } = useSelector((state: ReducerState) => state.locale);
  const [showMenu, setShowMenu] = useState(false);
  const [sorting, setSorting] = useState<TSortingValue>();
  const [hideStates, setHideStates] = useState<Record<string, boolean>>({
    states: true,
    cities: true,
    salary: true,
  });

  const toggleHide = (key: string) => {
    setHideStates(prev => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const query = useCallback(
    async (search: string = "", page: number = 1) => {
      try {
        setQueryError(false);
        const response = api.get<IPagination<TJob>>("/jobs/", {
          params: {},
        });
        const { data } = await response;
        return data;
      } catch {
        setQueryError(true);
        setNoResults && setNoResults(true);
      }
    },
    [
      segment,
      states,
      cities,
      salaryRange,
      published,
      setNoResults,
      perPage,
      userId,
    ]
  );

  function onChange(e: React.ChangeEvent<HTMLInputElement>) {
    setSearchData(e.target.value);
  }

  const segmentName = segment === "jobs" ? "Vagas" : "Serviços";

  return (
    <Styled.Container>
      {title ? (
        <HeaderPageTitle
          link={""}
          //sideChildren={!hideSorting && <Sorting setSorting={setSorting} />}
        >
          {title}
        </HeaderPageTitle>
      ) : (
        <HeaderPageTitle
          link={link}
          //sideChildren={!hideSorting && <Sorting setSorting={setSorting} />}
        >
          {segmentName}
        </HeaderPageTitle>
      )}
      {mobile && (
        <Styled.MobileFilterContainer>
          <Styled.ButtonContainer
            onClick={() => {
              setShowMenu(!showMenu);
            }}
          >
            Filtrar
          </Styled.ButtonContainer>
        </Styled.MobileFilterContainer>
      )}

      {mobile && (
        <div
          style={{
            flexDirection: "column",
            display: "flex",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Styled.FormContainer
            onChange={onChange}
            onKeyUp={e => {
              if (e.key === "Enter") {
                setSearch(searchData);
              }
            }}
          >
            <Styled.Search
              placeholder={"Buscar em Serviços"}
              onChange={e => {
                setSearchData(e.target.value);
              }}
              value={searchData || ""}
            />
            <Styled.SearchBtn
              type="submit"
              onClick={() => {
                setSearch(searchData);
              }}
            >
              <Styled.SearchIcon />
            </Styled.SearchBtn>
          </Styled.FormContainer>
        </div>
      )}

      <List2
        useData={useJobs}
        searchData={search}
        dataParams={{
          segment,
          states: states.map((state: IState) => state.id).join(","),
          cities: cities.map((city: ICity) => city.id).join(","),
          salary: stringRange(salaryRange, setSalaryRange),
          undefinedSalaries,
          published,
          perPage: perPage,
          userId: userId && userId,
        }}
        ItemLayout={(item: any) => (
          <ListItem
            viewCount={userId ? true : false}
            data={item}
            link={
              segment === "jobs"
                ? Routes.job.replace(":slug", item.slug ? item.slug : "")
                : Routes.service.replace(":slug", item.slug ? item.slug : "")
            }
          />
        )}
        hideSearch={hideSearch}
        displayOn={showMenu}
        setDisplayOn={setShowMenu}
        hideFilters={hideFilters}
        hidePagination={hidePagination}
        seeMoreLink={link}
        seeMoreText={`Ver mais ${segmentName.toLowerCase()}`}
        inline={inline}
        segment={segment}
        row={row}
      >
        <Styled.Filter>
          <Styledd.Container>
            <Styledd.SearchContainer>
              <Styledd.SearchTitleContainer>
                <Styledd.Title
                  style={{ color: "#1A1A1A" }}
                  searchHidden={false}
                  className="filters-title"
                  onClick={() => {}}
                >
                  Estados
                </Styledd.Title>
                {mobile && (
                  <Styled.Expand onClick={() => toggleHide("states")}>
                    {hideStates["states"] ? (
                      <IoIosArrowDown size={24} />
                    ) : (
                      <IoIosArrowUp size={24} />
                    )}
                  </Styled.Expand>
                )}
              </Styledd.SearchTitleContainer>
              <States
                name="states"
                hideSearch={hideStates["states"]}
                setValue={setStates}
                segment={segment}
                label=""
              />
            </Styledd.SearchContainer>
          </Styledd.Container>
          <Styledd.Container
            style={{
              maxHeight: "228px",
              overflowY: "auto",
            }}
          >
            <Styledd.SearchContainer>
              <Styledd.SearchTitleContainer>
                <Styledd.Title
                  style={{ color: "#1A1A1A" }}
                  searchHidden={false}
                  className="filters-title"
                  onClick={() => {}}
                >
                  Cidades
                </Styledd.Title>
                {mobile && (
                  <Styled.Expand onClick={() => toggleHide("cities")}>
                    {hideStates["cities"] ? (
                      <IoIosArrowDown size={24} />
                    ) : (
                      <IoIosArrowUp size={24} />
                    )}
                  </Styled.Expand>
                )}
              </Styledd.SearchTitleContainer>
              <Cities
                name="cities"
                hideSearch={hideStates["cities"]}
                setValue={setCities}
                states={states}
                segment={segment}
                hiddenLabel={true}
              />
            </Styledd.SearchContainer>
          </Styledd.Container>
          <Styledd.Container>
            <Styledd.SearchContainer>
              <Styledd.SearchTitleContainer>
                <Styledd.Title
                  style={{ color: "#1A1A1A" }}
                  searchHidden={false}
                  className="filters-title"
                  onClick={() => {}}
                >
                  Salário
                </Styledd.Title>
                {mobile && (
                  <Styled.Expand onClick={() => toggleHide("salary")}>
                    {hideStates["salary"] ? (
                      <IoIosArrowDown size={24} />
                    ) : (
                      <IoIosArrowUp size={24} />
                    )}
                  </Styled.Expand>
                )}
              </Styledd.SearchTitleContainer>
              <RangeField
                title=""
                name="salary"
                hideSearch={hideStates["salary"]}
                isCurrency={true}
                change={setSalaryRange}
                values={salaryRange}
                undefinedValues={undefinedSalaries}
                setUndefinedValues={setUndefinedSalaries}
                undefinedValuesMessage={`Incluir ${
                  segment === "jobs" ? "vagas" : "serviços"
                } com salário a combinar`}
              />
            </Styledd.SearchContainer>
          </Styledd.Container>
        </Styled.Filter>
      </List2>
    </Styled.Container>
  );
};

export default JobList;
